module.exports = __webpack_public_path__ + "aad4a0a9d0639c5af4d68a5b70ec4b19.png";